import { useAuthApolloClient, createHttpClient } from '@sit/client-shared';
import { useSelector } from 'react-redux';
import { config } from '../config/env';
import { selectToken } from '../redux/selectors';

export function useAppApolloClient(skip?: boolean) {
  const token = useSelector(selectToken);
  return useAuthApolloClient(token, config.graphqlUrl, config.subscriptionsUrl, skip);
}

export function createAppHttpClient(token: string | null) {
  return createHttpClient({ token, url: config.graphqlUrl });
}
